/* eslint-disable */
export default {
  forward: '착신 전환',
  ignore: '무시',
  toVoicemail: '음성 사서함에 보내기',
  answer: '응답',
  endAndAnswer: '종료 후 응답',
  holdAndAnswer: '대기 후 응답',
  custom: '사용자 지정',
  more: '더 보기',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"toVoicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"answer"@#@ @source: @#@"Answer"@#@
// @key: @#@"endAndAnswer"@#@ @source: @#@"End & Answer"@#@
// @key: @#@"holdAndAnswer"@#@ @source: @#@"Hold & Answer"@#@
// @key: @#@"custom"@#@ @source: @#@"Custom"@#@
// @key: @#@"more"@#@ @source: @#@"More"@#@
